import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Navbar } from "@/components/public/Navbar";
import { Hero } from "@/components/public/Hero";
import { RefillSection } from "@/components/public/RefillSection";
import { PurchasesSection } from "@/components/public/PurchasesSection";
import { AboutSection, Footer } from "@/components/public/Footer";

export default function PublicSite() {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  const scrollTo = (id) => {
    if (id === "order") return navigate("/order");
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const handleSelect = (product) => navigate(`/order?product=${product.id}`);

  return (
    <div className="bg-white">
      <Navbar />
      <Hero onScrollTo={scrollTo} />
      <RefillSection products={products} onSelect={handleSelect} />
      <PurchasesSection products={products} onSelect={handleSelect} />
      <AboutSection />
      <Footer />
    </div>
  );
}
